import { FC, SVGProps } from 'react';

const LockUnauthorizedIcon: FC<SVGProps<SVGSVGElement> & { size?: number }> = ({
  size = 20,
  color = '#EF5350',
  ...props
}) => {
  return (
    <svg width={size} height={size} viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M13.6862 7.87318V6.08402C13.6862 3.98985 11.9878 2.29148 9.89366 2.29148C7.79949 2.28235 6.09449 3.97235 6.08533 6.06735V6.08402V7.87318"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M13.0694 17.708H6.70187C4.95687 17.708 3.54187 16.2938 3.54187 14.548V10.9738C3.54187 9.22801 4.95687 7.81384 6.70187 7.81384H13.0694C14.8144 7.81384 16.2294 9.22801 16.2294 10.9738V14.548C16.2294 16.2938 14.8144 17.708 13.0694 17.708Z"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9.88574 11.8356V13.6864"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default LockUnauthorizedIcon;
